import { Button, Link, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';
import { QKey } from '../../../context';

export interface IBaseInsightInterface {
  onNext: () => void;
  onBack: () => void;
  nextText: string;
  animatedImage?: JSX.Element;
  text: string | string[];
  cite: string;
  href: string;
  questionKey: QKey;
}
const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      padding: '0px 13px 0px 0px',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '24px 270px 0px 180px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '24px 40px 0px 265px',
    },
  },
  insight: {
    fontWeight: 500,
    color: 'rgb(95,99,104)',
    lineHeight: '52px',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      letterSpacing: 0.31,
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 18,
      letterSpacing: 0.4,
    },
  },
  body: {
    fontWeight: 400,
    color: 'rgb(32,33,36)',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
      lineHeight: '32px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 34,
      letterSpacing: -0.4,
      lineHeight: '52px',
    },
  },
  footer: {
    margin: '20px 0 30px',
    fontSize: 12,
    letterSpacing: -0.06,
    lineHeight: '18px',
    display: 'block',
    fontWeight: 400,
    fontStyle: 'italic',
    color: 'rgb(95,99,104)',
  },
}));

export const BaseInsight: React.FC<IBaseInsightInterface> = ({
  onNext,
  nextText,
  text,
  cite,
  animatedImage,
  href,
  onBack,
  questionKey,
}) => {
  const { root, body, insight, footer } = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <div
      className={root}
      style={{
        paddingRight: matches
          ? 0
          : questionKey === 'q3'
          ? 180
          : questionKey === 'q8'
          ? 120
          : questionKey === 'q2'
          ? 60
          : undefined,
      }}
    >
      <h3 className={insight}>Insights: </h3>
      <p className={body}>
        {Array.isArray(text) ? (
          <>
            {text[0]}
            <span style={{ color: 'rgb(66, 133, 244)' }}>{text[1]}</span>
            {text[2]}
          </>
        ) : (
          text
        )}
      </p>
      <cite className={footer}>
      {href ? (
          <span
            style={{
              color: 'rgb(95,99,104)',
              fontStyle: 'normal',
            }}
          >
            Source:
            <Link
              href={href}
              target="blank"
              underline="none"
              style={{
                color: 'rgb(95,99,104)',
                fontStyle: 'normal',
                textDecoration: 'underline',
                marginLeft: 5,
              }}
            >
              {cite}
            </Link>  
          </span>
        ) : (
          cite
        )}
      </cite>
      {animatedImage}
      <div>
        <Button color="primary" variant="contained" onClick={onNext}>
          {nextText}
        </Button>
      </div>
    </div>
  );
};
